import { BiCardData, BiDashboardView } from '@euler/model/bi/dashboard';

// Captured from the dev rear (store 323, member 3855) over the BiService hop:
// the dashboard as created, and each card's data.

export const kBiRollingDashboardCaptured = {
  id: 'bidash_01m542jb0w6skrdgkj0szbnm7t',
  name: '滚动时间测试',
  description: null,
  visibility: 1,
  ownerMemberId: 3855,
  ownerName: '测试店长',
  isDefault: false,
  revision: 1,
  permission: 'manage',
  updatedAt: '2026-10-17T04:40:20.000Z',
  layout: {
    mode: 'preset',
    columns: 'auto',
    order: [
      'bicard_01m542jb1q1k4jnzxhs5mardp3',
      'bicard_01m542jb1r6hgjmkz28g9yp6j1',
    ],
  },
  filters: {},
  palette: 'default',
  cards: [
    {
      id: 'bicard_01m542jb1q1k4jnzxhs5mardp3',
      title: '近 12 个月订单趋势',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
        ],
        dimensions: [
          {
            field: 'created_at',
            grain: 'month',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'rolling',
          unit: 'month',
          count: 12,
          includeCurrent: true,
        },
      },
      viz: {
        type: 'line',
        x: 'created_at__month',
        series: [
          {
            key: 'order_count',
          },
        ],
      },
      sourceDraftId: 'bidraft_01m542jb18hmzkpahaejw615tz',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:20.000Z',
      updatedAt: '2026-10-17T04:40:20.000Z',
    },
    {
      id: 'bicard_01m542jb1r6hgjmkz28g9yp6j1',
      title: '前两个季度工单数',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
        ],
        dimensions: [],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'rolling',
          unit: 'quarter',
          count: 2,
          includeCurrent: false,
        },
      },
      viz: {
        type: 'kpi',
        value: 'order_count',
        compare: 'previous_period',
      },
      sourceDraftId: 'bidraft_01m542jb1gdjx3m4qmdhn0qx9v',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:20.000Z',
      updatedAt: '2026-10-17T04:40:20.000Z',
    },
  ],
  createdAt: '2026-10-17T04:40:20.000Z',
} as unknown as BiDashboardView;

export const kBiRollingCardDataCaptured = {
  bicard_01m542jb1q1k4jnzxhs5mardp3: {
    state: 'ready',
    cardId: 'bicard_01m542jb1q1k4jnzxhs5mardp3',
    result: {
      current: {
        columns: [
          {
            key: 'created_at__month',
            label: {
              zh: '开单时间（月）',
              en: 'Opened at (month)',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['2025-11', 1494],
          ['2025-12', 1501],
          ['2026-01', 1687],
          ['2026-02', 1643],
          ['2026-03', 1579],
          ['2026-04', 1407],
          ['2026-05', 1236],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:20.289Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-17',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jb1r6hgjmkz28g9yp6j1: {
    state: 'ready',
    cardId: 'bicard_01m542jb1r6hgjmkz28g9yp6j1',
    result: {
      current: {
        columns: [
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [[2643]],
        truncated: false,
        asOf: '2026-10-17T04:40:20.299Z',
        window: {
          from: '2026-04-01',
          to: '2026-09-30',
        },
      },
      previous: {
        columns: [
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [[9484]],
        truncated: false,
        asOf: '2026-10-17T04:40:20.299Z',
        window: {
          from: '2025-10-01',
          to: '2026-03-31',
        },
      },
    },
    dateFilter: 'none',
  },
} as unknown as Record<string, BiCardData>;

export const kBiRollingFilteredCaptured = {
  state: 'ready',
  cardId: 'bicard_01m542jb1q1k4jnzxhs5mardp3',
  result: {
    current: {
      columns: [
        {
          key: 'created_at__month',
          label: {
            zh: '开单时间（月）',
            en: 'Opened at (month)',
          },
          type: 'string',
          role: 'dimension',
        },
        {
          key: 'order_count',
          label: {
            zh: '工单数',
            en: 'Orders',
          },
          type: 'number',
          role: 'measure',
          format: { kind: 'number', decimals: 0 },
        },
      ],
      rows: [
        ['2026-01', 1687],
        ['2026-02', 1643],
        ['2026-03', 1579],
        ['2026-04', 1407],
        ['2026-05', 1236],
      ],
      truncated: false,
      asOf: '2026-10-17T04:40:20.306Z',
      window: {
        from: '2026-01-01',
        to: '2026-09-30',
      },
    },
  },
  dateFilter: 'applied',
} as unknown as BiCardData;

export const kBiRollingAbsoluteCaptured = {
  state: 'ready',
  cardId: 'bicard_01m542jb1q1k4jnzxhs5mardp3',
  result: {
    current: {
      columns: [
        {
          key: 'created_at__month',
          label: {
            zh: '开单时间（月）',
            en: 'Opened at (month)',
          },
          type: 'string',
          role: 'dimension',
        },
        {
          key: 'order_count',
          label: {
            zh: '工单数',
            en: 'Orders',
          },
          type: 'number',
          role: 'measure',
          format: { kind: 'number', decimals: 0 },
        },
      ],
      rows: [],
      truncated: false,
      asOf: '2026-10-17T04:40:20.316Z',
      window: {
        from: '2026-07-01',
        to: '2026-09-30',
      },
    },
  },
  dateFilter: 'applied',
} as unknown as BiCardData;
